export default __webpack_public_path__ + "static/media/checked.accb5551.svg";